<img [src]="_cardTypeIcon" width="32" height="32">
